var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("系统消息")]),_c('div',{staticClass:"list"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index},[_vm._v(_vm._s(item.offMessage.mailContent))])}),0),_c('hxlPagin',{attrs:{"queryParams":_vm.queryParams},on:{"changePage":_vm.changePage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }